<template>
  <div
    slot="scrollbar"
    class="page-layout__intro-text"
    :class="{'page-layout__intro-text--bottom': placeTextBottom}"
  >
    <v-container :class="{'text-center': !placeTextBottom}">
      <h1 v-if="title">
        {{ title }}
      </h1>
      <div
        v-if="text"
        class="page-layout__intro-description"
      >
        {{ text }}
      </div>
      <v-btn
        v-if="buttonText"
        color="primary"
        size="large"
        @click.native="$emit('action')"
      >
        {{ buttonText }}
      </v-btn>
    </v-container>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator'

@Component({})

export default class PageLayoutIntroText extends Vue {
  @Prop({ type: String }) title!: string
  @Prop({ type: String }) text!: string
  @Prop({ type: String }) buttonText!: string; g
  @Prop({ type: Boolean }) placeTextBottom!: boolean
}
</script>
